
<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="docPayants?.non" 
 
[label]="step11.getspan17"
[type]="'radio'"
[rule]="'pattern_29'"
[value]="radioButtonValue"
[name]="radioButtonCtrlName"
[radios]="[
						{
                            value: oui,
							label: step11.getoui
						},
						{
							value: non,
							label: step11.getnon
						}
					]">
</app-form-input>

<app-oui *ngIf="getIsOui()" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [oui]="docPayants?.oui"></app-oui>


